import { buildGuideLinks } from "@plaatplan/i18n";
import { useMemo } from "react";
import { useLocale } from "./useLocale.js";

export function useGuideLinks() {
  const { preferences } = useLocale();
  return useMemo(
    () => buildGuideLinks(preferences.locale),
    [preferences.locale],
  );
}
